import service from '@/services/SIRqsmartBitacora';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener el resultado de hacer un Qsmart.
     */
    read({ dispatch }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsData: {
            eeDatos: [
              {
                picfiid: values?.token,
                picusrcod: values?.user,
              },
            ],
            eeSIRqsmart: [
              {
                fileType: values?.fileType,
                sal_cod: values?.sal_cod,
              },
            ],
          },
        };

        let notification;

        service
          .read(payload)
          .then((response) => {
            const data = response.data.dsData;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
